export default {
  birthsConsultations:{},
  selectedAnimal:null
}